import { useEffect, useRef, useState } from 'react'

interface VisibleChar {
  char: string
  key: number
  delay: number
}

export const useChatbotTypingEffect = (
  animationDuration: number,
  originalText?: string,
  time = 20,
  skipAnimation = false,
) => {
  const [animationFinished, setAnimationFinished] = useState(false)
  const [visibleChars, setVisibleChars] = useState<VisibleChar[]>([])
  const index = useRef(0)
  const batchCounter = useRef(0)

  useEffect(() => {
    let typingInterval: NodeJS.Timeout | null = null
    setVisibleChars([])
    setAnimationFinished(false)

    if (!originalText) return

    if (skipAnimation) {
      setVisibleChars(
        originalText.split('').map((char, i) => ({ char, key: i, delay: 0 })),
      )
      setAnimationFinished(true)
    } else {
      index.current = 0
      batchCounter.current = 0

      typingInterval = setInterval(() => {
        if (index.current < originalText.length) {
          setVisibleChars((prev) => {
            const nextChars: VisibleChar[] = []
            for (
              let i = 0;
              i < 5 && index.current < originalText.length;
              i++, index.current++
            ) {
              nextChars.push({
                char: originalText.charAt(index.current),
                key: index.current,
                delay: batchCounter.current * 2,
              })
            }
            batchCounter.current++
            return [...prev, ...nextChars]
          })
        } else {
          if (typingInterval) clearInterval(typingInterval)
          setTimeout(() => setAnimationFinished(true), animationDuration)
        }
      }, time)
    }

    return () => {
      if (typingInterval) clearInterval(typingInterval)
    }
  }, [originalText, time, skipAnimation, animationDuration])

  return { visibleChars, animationFinished }
}
